// extracted by mini-css-extract-plugin
export var menuIcon = "_r4-0";
export var menuIconInline = "_r4-1";